/* import __COLOCATED_TEMPLATE__ from './two-columns-title-image-text.hbs.js'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();